import Image from "next/image";

import type { Guardian } from "@sorcery/db";

import { earth, fire, water, wind } from "~/utils/element";

export const CardThreshholds = ({ guardian }: { guardian: Guardian }) => {
  return (
    <>
      {!!guardian.earthThreshold &&
        [...Array(Number(guardian.earthThreshold))].map((_, i) => (
          <Image
            src={earth}
            className="mt-[1px] inline-block h-[15px] w-[15px]"
            alt=""
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            key={i}
          />
        ))}

      {!!guardian.fireThreshold &&
        [...Array(Number(guardian.fireThreshold))].map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <Image src={fire} className="mt-[1px] inline-block h-[15px] w-[15px]" alt="" key={i} />
        ))}

      {!!guardian.waterThreshold &&
        [...Array(Number(guardian.waterThreshold))].map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <Image src={water} className="mt-[1px] inline-block h-[15px] w-[15px]" alt="" key={i} />
        ))}

      {!!guardian.airThreshold &&
        [...Array(Number(guardian.airThreshold))].map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <Image src={wind} className="mt-[1px] inline-block h-[15px] w-[15px]" alt="" key={i} />
        ))}
    </>
  );
};
